<app-headless-window *ngIf="isHeadless"></app-headless-window>
<app-main-window *ngIf="!isHeadless"></app-main-window>
